// eslint-disable-next-line import/prefer-default-export
export const getObjectFields = (obj, prohibited = ['id']) =>
  Object.keys(obj).filter(key => prohibited.indexOf(key) === -1);
